import { createBrowserRouter, Outlet, redirect } from "react-router";
import { PATHS } from "./paths";
import SignIn from "../signin/sign-in";
import React from "react";
import Header from "../header/Header";
import Dashboard from "../dashboard/Dashboard";
import { OpeningHours } from "../opening-hours/OpeningHours";
import { Container } from "@mui/material";
import {Staff} from "../staff/Staff";

function requireAuth() {
  // Your Cognito App Client ID must be set in an env var at build time
  const clientId = process.env.REACT_APP_COGNITO_APP_CLIENT_ID!;
  // The key where Cognito stores the last signed-in username
  const lastUserKey = `CognitoIdentityServiceProvider.${clientId}.LastAuthUser`;
  const username = localStorage.getItem(lastUserKey);
  if (!username) {
    return redirect(PATHS.signIn);
  }
  // The key for the idToken for that user
  const tokenKey = `CognitoIdentityServiceProvider.${clientId}.${username}.idToken`;
  const idToken = localStorage.getItem(tokenKey);
  if (!idToken) {
    return redirect(PATHS.signIn);
  }
  return null; // Auth OK
}

// Layout wrapper that renders child routes after auth check
function ProtectedLayout() {
  return (
    <>
      <Header />
      <Container maxWidth="lg" sx={{ mt: 2, mb: 2 }}>
        <Outlet />
      </Container>
    </>
  );
}

export const router = createBrowserRouter([
  {
    element: <ProtectedLayout />,
    loader: requireAuth,
    children: [
      { path: PATHS.dashboard, element: <Dashboard /> },
      { path: PATHS.openingHours, element: <OpeningHours /> },
      { path: PATHS.staff, element: <Staff /> },
    ],
  },
  { path: PATHS.signIn, element: <SignIn /> },
]);
